import { render, staticRenderFns } from "./SpecialBoxes.vue?vue&type=template&id=6bd92174&"
import script from "./SpecialBoxes.vue?vue&type=script&lang=js&"
export * from "./SpecialBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports